import script from "./SupportDispatch.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportDispatch.vue?vue&type=script&setup=true&lang=js"

import "./SupportDispatch.vue?vue&type=style&index=0&id=55234490&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55234490"]])

export default __exports__